export default __webpack_public_path__ + "1.17.16/static/media/LibreDataSharecode_Arabic.210c4f6c.svg";